import i18n from "@/shared/config/i18n";

const KK_KZ = ["kk", "kz"];

function currentLocale(fallback) {
  if (fallback) return String(fallback).toLowerCase();
  // legacy mode: i18n.global.locale — обычная строка; composition mode — Ref.
  const loc = i18n?.global?.locale;
  const value =
    loc && typeof loc === "object" && "value" in loc ? loc.value : loc;
  return String(value || "ru").toLowerCase();
}

export function getLocalizedMessage(detail, fallbackLocale) {
  if (!detail) return null;
  if (typeof detail === "string") return detail;

  const locale = currentLocale(fallbackLocale);

  // Бэк может вернуть { ru, kz, en, status } — нормализуем kk↔kz.
  const candidates = [
    detail[locale],
    KK_KZ.includes(locale) ? detail.kk || detail.kz : null,
    detail.ru,
    detail.en,
    detail.message,
  ].filter(Boolean);

  return candidates[0] || null;
}

export function getErrorCode(detail) {
  if (!detail || typeof detail === "string") return null;
  return detail.status || detail.code || null;
}
